import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button'
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrandOfferComponent } from './brand-offer/brand-offer.component';
import { BrandCategoriesComponent } from './brand-categories/brand-categories.component';
import { TranslateModule } from '@ngx-translate/core';
import { MerchantUserComponent } from './merchant-user/merchant-user.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { BrandsComponent } from './brands/brands.component';
import { FooterComponent } from './footer/footer.component';

@NgModule({
  declarations: [HeaderComponent, BrandOfferComponent, BrandCategoriesComponent, MerchantUserComponent, BrandsComponent, FooterComponent],
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxPaginationModule,
    TranslateModule.forChild(),
  ],
  exports: [
    RouterModule,
    MatButtonModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    HeaderComponent,
    BrandOfferComponent,
    BrandCategoriesComponent,
    MerchantUserComponent,
    NgxPaginationModule,
    BrandsComponent,
    FooterComponent
    ]
})
export class SharedModule { }
